import IconSavingsOutline from '@assets/icons/IconSavingsOutline';
import useAppConfig from '@hooks/useAppConfig';

const MoneyboxIcon = () => {
  const {
    data: {
      modules: {
        MoneyBox: { icon },
      },
    },
  } = useAppConfig();

  return icon ? (
    <div
      tw="w-4 h-4 bg-center bg-cover place-self-center"
      css={`
        background-image: url(${icon});
      `}
      data-cy="MoneyboxIcon_div"
    />
  ) : (
    <IconSavingsOutline />
  );
};

export default MoneyboxIcon;
